export const JOB_KEYS = {
  all: () => ["jobs"] as const,
  forEstimate: (estimateId: string) => [...JOB_KEYS.all(), "estimate", estimateId] as const,
  detail: (jobId: string) => [...JOB_KEYS.all(), "detail", jobId] as const,
};
